const englishId = '66c6e560fc64db42edc80807';

export function getRecommendedFeatures(data: any, common: any, userData: any) {
	let result: {
		_id: string;
		group: string;
		type: string;
		name: string;
		file: string | undefined;
	}[] = [];

	const isScenesV3Enabled =
		userData?.tests?.scenesV3 && userData?.learningLanguage === englishId;

	if (data) {
		for (let i = 0; i < 4; i++) {
			if (data.lesson?.length > 0 && data.lesson[i] && !isScenesV3Enabled) {
				result.push({
					_id: data.lesson[i]._id,
					group: 'scenes',
					type: common['scenes'],
					name: data.lesson[i].name,
					file: data.lesson[i].file[0]?.base64,
				});
			}

			if (data.scenesV3?.length > 0 && data.scenesV3[i] && isScenesV3Enabled) {
				result.push({
					_id: data.scenesV3[i]._id,
					group: 'scenes_v3',
					type: common['scenes_v3'],
					name: data.scenesV3[i].name,
					file: data.scenesV3[i].file[0]?.base64,
				});
			}

			if (
				userData?.language !== 'es' ||
				userData?.learningLanguage !== '65e87eb89eb450e599349dae'
			) {
				if (data.flashcard?.length > 0 && data.flashcard[i]) {
					result.push({
						_id: data.flashcard[i]._id,
						group: 'flashcards_v2',
						type: common['flashcards'],
						name: data.flashcard[i].name,
						file: data.flashcard[i].file[0]?.base64,
					});
				}
			}

			if (data.wordLessonType?.length > 0 && data.wordLessonType[i]) {
				result.push({
					_id: data.wordLessonType[i]._id,
					group: 'words',
					type: common['words'],
					name: data.wordLessonType[i].name,
					file: data.wordLessonType[i].file[0]?.base64,
				});
			}
		}
	}

	return result;
}
